import React from 'react'
import ModalDetailComponent from '../components/ModalDetailComponent'
import { useDispatch, useSelector } from 'react-redux';
import { openDetail } from '../redux/slice/sensorSlice';

const FormDetailSensor = () => {
    const dispatch = useDispatch();
    const { dataSensor, isOpenSensor, isLoading, isOpenDetailSensor, dataByIdSensor } = useSelector( (state) => state.sensor );
    // console.log(dataByIdSensor.detailCamera.location)
  return (
    <ModalDetailComponent
    title="DETAIL DATA SENSOR"
    show={isOpenDetailSensor}
    close={() => dispatch(openDetail({ open: false, type: 'close' }))}
    idForm="detailCamera-form"
  >
      <div className="row" style={{ alignItems: 'center'}}>
          <div className="col-xl-6">
              <table className="table">
                  <thead>
                      <tr>
                          {/* <span> Detail Data Kamera </span> */}
                       </tr>
                  </thead>
                  <tbody>
                      <tr> Nama Lokasi : {dataByIdSensor.name} </tr>
                      <tr> Nilai :  {dataByIdSensor.value} </tr>
                      <tr> Nama Site : {dataByIdSensor.siteId} </tr>
                      <tr> ZMQ : {dataByIdSensor.zmq} </tr>
                      <tr> Alamat ZMQ : {dataByIdSensor.zmqAddress} </tr>
                      <tr> Nilai Confidence : {dataByIdSensor.confidenceVal} </tr>
                      {/* <tr> Nama Perangkat : {dataByIdSensor.counting} </tr> */}
                      {/* <tr> Nama Analytic : {dataByIdSensor.detailAnalytic} </tr> */}
                  </tbody>
              </table>
          </div>
          <div className="col-xl-6">
              <tbody>
                  {/* <tr> Nama Kamera : {dataByIdSensor.detailCamera.nameCamera} - {dataByIdSensor.detailCamera.location} </tr> */}
                  <tr> Durasi :  {dataByIdSensor.detDuration} </tr>
                  <tr> Garis Deteksi :  {dataByIdSensor.lineDetection} </tr>
                  <tr> Garis Lewat Bingkai :  {dataByIdSensor.skipFrame} </tr>
                  <tr> Nama File Geti :  {dataByIdSensor.getiFile} </tr>
                  <tr> Tipe Perangkat  :  {dataByIdSensor.minioId} </tr>
                  {/* <tr> Nama Lokasi :  {dataByIdSensor[0].siteName} </tr> */}
              </tbody>
          </div>
      </div>
  </ModalDetailComponent>
  )
}

export default FormDetailSensor